import React from 'react'

import './choose-your-need.scss'

const NeedItem = ({
  title,
  text,
  url,
  linkText = 'Szczegóły oferty',
  inverse = false,
}) => (
  <article
    className={`need-item ${inverse ? 'need-item--colors-inverse' : ''}`}
  >
    <h2 className="need-item__title h3">{title}</h2>
    {!!text && <div className="need-item__desc">{text}</div>}
    <a
      href={url}
      className={`for-restaurants-cta-btn need-item__link ${
        inverse ? 'need-item__link--inverse ' : 'cta-btn--secondary'
      }`}
    >
      {linkText}
    </a>
  </article>
)

const ChooseYourNeed = props => {
  return (
    <div className={`container ${props.className || ''}`}>
      <h2 className="col-12 text-center mb-3">
        Czy i w jaki sposób sprzedajesz online?
      </h2>
      <div className="restaurateur-needs">
        <NeedItem
          title="Nie sprzedaję online"
          linkText="Zobacz, jak możesz zacząć"
          url="/dla-restauracji/zacznij-sprzedawac-online"
        />
        <NeedItem
          title={
            <>
              Sprzedaję online i chcę{' '}
              <span className="need-item__title--underline">
                obniżyć prowizję portali
              </span>
            </>
          }
          text={
            <p>
              Jesteś zmęczony tym, że duże portale zabierają większą część
              Twoich zarobków, pobierając przesadnie dużą prowizję?
            </p>
          }
          url="/dla-restauracji/obniz-prowizje-portali"
          linkText="Zobacz, jak ją zmniejszyć"
        />
        <NeedItem
          title={
            <>
              Chcę dołączyć do portalu i{' '}
              <span className="need-item__title--inverse-colors-underline">
                zwiększyć obroty
              </span>
            </>
          }
          text={
            <p>
              OtoStolik nie oferuje takiej możliwości, ale zapraszamy do
              skorzystania z oferty portalu{' '}
              <a href="https://www.lubje.pl/">
                <img
                  src="https://otostolik.pl/storage/img/lubje/logo-lubje-color-v3.svg"
                  alt="LUBJE logo"
                  className="need-item__img"
                />
              </a>{' '}
              , stworzonego przez restauratorów, którego jesteśmy partnerem
              technologicznym.
            </p>
          }
          url="https://www.lubje.pl/"
          inverse
        />
      </div>
    </div>
  )
}

export default ChooseYourNeed
